import { UserInfo } from '#/store';
import { selectInfo, selectPcSwitch } from '@/api/sys/common';
import { accountPermission } from '@/api/sys/user';
import { defineStore } from 'pinia';
import { usePermissionStore } from './permission';
import { useUserStore } from './user';
import { RoleEnum } from '@/enums/roleEnum';
import { PageEnum } from '@/enums/pageEnum';
import { clearCache } from '@/api/sys/cache';
import { router } from '@/router';

interface IItem {
  id: number | string;
  name: string;
}
interface ISelectInfo {
  agent_order_status: IItem[];
  agent_return_order_status: IItem[];
  agent_return_order_type: IItem[];
  base_bool: IItem[];
  express_list: IItem[];
  sn_owner: IItem[];
  product_is_main: IItem[];
  product_sale_channel: IItem[];
  product_sn_type: IItem[];
  warehouse_entry_status: IItem[];
  warehouse_entry_type: IItem[];
  warehouse_out_status: IItem[];
  warehouse_out_type: IItem[];
  purchase_order_status: IItem[];
  purchase_order_type: IItem[];
  sales_usage: IItem[];
  sales_logistics_type: IItem[];
  agent_bill_type: IItem[];
  role_type: IItem[];
  resource_type: IItem[];
}

interface ICommonState {
  selectInfo: ISelectInfo;
  userInfo: UserInfo;
  systemType: string;
  storeList: any[];
  pcSwitchCashier: number;
}

export const useCommonStore = defineStore({
  id: 'common',
  state: (): ICommonState => ({
    selectInfo: {
      agent_order_status: [],
      agent_return_order_status: [],
      agent_return_order_type: [],
      base_bool: [],
      express_list: [],
      sn_owner: [],
      product_is_main: [],
      product_sale_channel: [],
      product_sn_type: [],
      warehouse_entry_status: [],
      warehouse_entry_type: [],
      warehouse_out_status: [],
      warehouse_out_type: [],
      purchase_order_status: [],
      purchase_order_type: [],
      sales_usage: [],
      sales_logistics_type: [],
      agent_bill_type: [],
      role_type: [],
      resource_type: [],
    },
    userInfo: {
      id: 0,
      account: '',
      name: '',
      mobile_number: '',
      email: '',
      status: 0,
      status_text: '',
      store_nums: [],
      customer_num: '',
      customer_name: '',
      current_store_num: '',
      current_store: {
        store_num: '',
        name: '',
      },
      current_role_type: 0, // 1总部、2门店
      current_store_type: 0, // 1自营门店、2经销商门店
      current_store_status: 0, // 门店状态: 0 筹备（默认） 1 开业 2 停业 3闭店
      customer_type: 0,
      current_store_name: '',
      store_list: [],
      role_types: [],
      head_store_list: [],
      resource_list: [],
      workcode: '',
      super_flag: 0,
      customer_list: [],
      head_customer_list: [],
    },
    systemType: RoleEnum.ONLINE,
    storeList: [],
    pcSwitchCashier: 0,  // 收银系统点击的灰度开关 0可以支付，1是不可以支付
  }),
  getters: {
    getSelectInfo(state): ISelectInfo {
      return state.selectInfo;
    },
    getUserInfo(state): UserInfo {
      return state.userInfo;
    },
    getStoreList(state): any[] {
      return state.storeList;
    },
    isStore(state) {
      return state.userInfo.current_role_type === 2;
    },
    isHead(state) {
      return state.userInfo.current_role_type === 1;
    },
    getPcSwitchCashier(state) {
      return state.pcSwitchCashier;
    },
  },
  actions: {
    // 获取用户信息
    async init() {
      clearCache();
      await this.setUserInfo(); // 获取用户信息
      await this.setSelectInfo();
      const pStore = usePermissionStore();
      await pStore.buildRoutesAction();
      await this.setPcSwitchCashier();
    },
    async setPcSwitchCashier() {
      if (Number(this.userInfo?.current_role_type) === 2) {
        selectPcSwitch({ type: 'pcCashier' }).then((res) => {
          this.pcSwitchCashier = res.switchStatus;
        });
      }
    },
    async setSelectInfo() {
      selectInfo().then((res) => {
        this.selectInfo = res;
      });
    },
    async setUserInfo() {
      try {
        const res = await accountPermission();
        const userStore = useUserStore();
        userStore.setToken('astore');
        this.userInfo = res;
        await this.setBaseHome();
        await this.setStoreList();
      } catch (error) {
        console.log('获取用户信息失败', error);
      }
    },
    async setStoreList() {
      const { head_store_list } = this.userInfo;
      this.storeList = head_store_list || [];
    },
    async setBaseHome() {
      const userStore = useUserStore();
      // 根据来源设置首页路由
      const { resource_list } = this.userInfo;
      userStore.setRoleList(resource_list || []);
      PageEnum.BASE_HOME = PageEnum.OFFLINE_HOME;
      await userStore.afterLoginAction();
      const path = window.location?.href || '';
      const pathRouter = path?.split('.com')?.[1];
      let toPath = pathRouter && pathRouter !== '/' ? pathRouter : PageEnum.BASE_HOME;
      if (toPath.includes('exception/401') && resource_list?.length > 0) {
        toPath = PageEnum.BASE_HOME;
      }
      router.replace(toPath);
    },
  },
});
